// frontend/src/auth/acl.ts
import { useMemo } from 'react';

/* =========================================================
   1️⃣ HABILIDADES DISPONIBLES
   ========================================================= */
export const A = {
  ReportsView: 'ReportsView',       // Ver reportes / dashboard
  CompaniesView: 'CompaniesView',   // Ver / gestionar empresas
  UsersView: 'UsersView',           // Ver / gestionar usuarios
  RolesView: 'RolesView',           // Ver / gestionar roles
} as const;

export type Ability = keyof typeof A;

/* =========================================================
   2️⃣ FUNCIÓN DE CONTROL DE ACCESO (useAcl)
   ========================================================= */

/**
 * Retorna un objeto con:
 *  - can(ability): boolean
 *  - me: { first_name, last_name, roles: string[] }
 */
export function useAcl() {
  // Cargamos usuario desde localStorage o context (según tu implementación)
  const me = useMemo(() => {
    try {
      const raw =
        localStorage.getItem('user') ??
        sessionStorage.getItem('user');
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }, []);

  // Extraemos roles del usuario
  const roles: string[] = useMemo(() => {
    return Array.isArray(me?.roles)
      ? me.roles.map((r: string) => r.toUpperCase())
      : [];
  }, [me]);

  // Función can(): valida si el rol del usuario tiene permiso sobre cierta habilidad
  function can(ability: Ability): boolean {
    if (!ability) return false;

    // El gerente tiene acceso total
    if (roles.includes('DEVIOZ_GERENTE')) return true;

    switch (ability) {
      case 'ReportsView':
        return (
          roles.includes('DEVIOZ_GERENTE') ||
          roles.includes('DEVIOZ_ADMIN')
        );

      case 'CompaniesView':
      case 'UsersView':
      case 'RolesView':
        return (
          roles.includes('DEVIOZ_ADMIN') ||
          roles.includes('DEVIOZ_GERENTE')
        );

      default:
        return false;
    }
  }

  return { can, me };
}
